import React, { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { DomainNotificationBuilderView } from '../../components/notification-builder/views/domain-notification-builder-view'

export const MobileSendNotification = () => {
    const { domainId } = useParams<{ domainId: string }>()
    const getParentRoute = useCallback(() => `/domains/${domainId}/dashboard`, [domainId])

    return (
        <DomainNotificationBuilderView
            isMobile={true}
            formMode="create"
            hideEstimatedReach={true}
            hidePreview={true}
            hideVariantManager={true}
            hideTestConfig={true}
            hidePushlyAiToggle={true}
            getParentRoute={getParentRoute}
        />
    )
}
